"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalSettings = exports.isValidCognitoToken = exports.createRunWithAmplifyServerContext = void 0;
var createRunWithAmplifyServerContext_1 = require("./createRunWithAmplifyServerContext");
Object.defineProperty(exports, "createRunWithAmplifyServerContext", { enumerable: true, get: function () { return createRunWithAmplifyServerContext_1.createRunWithAmplifyServerContext; } });
var isValidCognitoToken_1 = require("./isValidCognitoToken");
Object.defineProperty(exports, "isValidCognitoToken", { enumerable: true, get: function () { return isValidCognitoToken_1.isValidCognitoToken; } });
var globalSettings_1 = require("./globalSettings");
Object.defineProperty(exports, "globalSettings", { enumerable: true, get: function () { return globalSettings_1.globalSettings; } });
